import { useTranslation } from "react-i18next";

function CertificateStatusBadge({ expirationDate }) {
  const { t } = useTranslation();

  if (!expirationDate) {
    return (
      <span className="inline-flex items-center rounded-full bg-gray-100 px-2.5 py-0.5 text-xs font-medium text-gray-600">
        {t("cert-mgmt.no-certificate", { defaultValue: "No certificate" })}
      </span>
    );
  }

  const now = new Date();
  const expDate = new Date(expirationDate);
  const diffMs = expDate.getTime() - now.getTime();
  const diffDays = Math.ceil(diffMs / (1000 * 60 * 60 * 24));

  if (diffDays < 0) {
    return (
      <span className="inline-flex items-center rounded-full bg-red-100 px-2.5 py-0.5 text-xs font-medium text-red-700">
        {t("cert-mgmt.expired", { defaultValue: "Expired" })}
      </span>
    );
  }

  if (diffDays <= 30) {
    return (
      <span className="inline-flex items-center rounded-full bg-yellow-100 px-2.5 py-0.5 text-xs font-medium text-yellow-700">
        {t("cert-mgmt.expires-in", { defaultValue: "Expires in {{days}}d", days: diffDays })}
      </span>
    );
  }

  return (
    <span className="inline-flex items-center rounded-full bg-green-100 px-2.5 py-0.5 text-xs font-medium text-green-700">
      {t("cert-mgmt.valid", { defaultValue: "Valid ({{days}}d)", days: diffDays })}
    </span>
  );
}

export default CertificateStatusBadge;
